export const changeLoginModalVisibility = (content) => ({
  type: 'changeLoginModalVisibility',
  payload: content,
});

export const changeHelpModalVisibility = (content) => ({
  type: 'changeHelpModalVisibility',
  payload: content,
});
